import { getCountry } from './getCountry';
import { getCountryLanguages, getCountryMsLocales, CultureData } from 'country-language';
import { IncomingMessage, ServerResponse } from 'http';
import consts from '../util/consts';

interface Geolocation {
  res?: ServerResponse,
  req?: IncomingMessage,
  ip?: string,
  cookies?: {
    locale?: string,
    country?: string,
    region?: string,
    disableCountry?: string,
  },
}

export default async function getGeolocation({ res, req, ip, cookies }: Geolocation) {
  let shortLocale = 'en';
  let locale = cookies?.locale || null;
  let country = cookies?.country || null;
  let region = cookies?.region || null;
  let secondaryLocales;

  if (locale === 'en') {
    locale = 'en-US';
  }

  const browserLanguages =
    req?.headers['accept-language']?.slice(0, req?.headers['accept-language']?.indexOf(';'))
      .split(',') || [];

  if (res?.statusCode === 200) {
    if (!locale || !country) {
      const fetchedCountry = await getCountry(ip === '127.0.0.1' || ip === '::1' ? '' : ip || '');
      //
      // country = 'JP'
      country = fetchedCountry || 'US';

      const cultureCountries = getCountryMsLocales(country || 'US');
      const cultrureLanguages = browserLanguages.length === 0 ? [cultureCountries[0]] :
        browserLanguages.map(lang => (
          cultureCountries.find(culture =>
            culture.langCultureName.toLowerCase() === lang.toLowerCase(),
          ) || {} as CultureData
        ));

      locale = country ? cultrureLanguages[0].langCultureName || consts.DEFAULT_LOCALE :
        consts.DEFAULT_LOCALE;

      secondaryLocales = cultrureLanguages.slice(1, cultrureLanguages.length);

      shortLocale = country ?
        getCountryLanguages(country)[0].iso639_1 || consts.DEFAULT_LOCALE.slice(0, 2) :
        consts.DEFAULT_LOCALE.slice(0, 2);
    }
  }

  return {
    shortLocale,
    browserLanguages,
    secondaryLocales,
    locale,
    country,
    region,
  };
}
